export default "__VITE_ASSET__CykJZMC1__"